import { useUserProvider } from "@wt/game/providers/user/UserProvider";

// Desktop only
export const SidebarAd = () => {
  const { user } = useUserProvider();

  if (user.isPremium) {
    return <></>;
  }

  return (
    <div className="hidden lg:flex ipad:h-[110px] ipad:w-full desktop:h-[600px] desktop:w-[390px]">
      <div id="adngin-sidebar-0"></div>
    </div>
  );
};
